import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=bfd457e8&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=bfd457e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd457e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfd457e8')) {
      api.createRecord('bfd457e8', component.options)
    } else {
      api.reload('bfd457e8', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=bfd457e8&scoped=true&", function () {
      api.rerender('bfd457e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/transit_dealer_management/special_orders/form/detail.vue"
export default component.exports